export default __webpack_public_path__ + "static/ec-1-sm-7bb156e46e19b22da01f8192c4cd1ae4.png";